import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'providerStatusClasses',
})
export class ProviderStatusClassesPipe implements PipeTransform {
  transform(isActive: boolean, isHovered: boolean): string {
    if (isHovered) {
      return isActive
        ? 'bg-gray-200 text-gray-800 shadow-lg'
        : 'bg-green-200 text-green-800 shadow-lg';
    } else {
      return isActive ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800';
    }
  }
}
